import {
  Alert,
  App,
  Button,
  Checkbox,
  Input,
  Modal,
  notification,
  Radio,
  Space,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useContext, useEffect, useRef, useState } from "react";
import routes from "../../../engine/routes";
import CustomForm from "../CustomForm";
import { useParams } from "react-router-dom";
import { mainTypesPrestation } from "../../../utils/typesPrestation";
import { userHasLevel } from "../../../engine/AuthRoute";
import {
  daysJsFormat,
  modeInterpretariat,
  renderUserName,
  roles,
  statusPrestationsValues,
  subStatus,
  typeIntervention,
} from "../../../utils/constants";
import { createPortal } from "react-dom";

import { FcCancel } from "react-icons/fc";
import { defaultProps, modalsByContext } from "./modals";
import dayjs from "../../../utils/dayjs";
import {
  followPrestation,
  setPropertiesPrestation,
  updatePrestation,
} from "../../../pages/Prestations/Slices/Prestation.slice";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { UserContext } from "../../../engine/context/User.context";
import { MdOutlineFreeCancellation } from "react-icons/md";
import { AiFillCalendar } from "react-icons/ai";
import { FiCheckCircle } from "react-icons/fi";
import {
  initendDate,
  initstartDate,
} from "../../../pages/Prestations/Slices/Prestation.default.state";
import { BiLinkExternal } from "react-icons/bi";
import { FaCheckDouble } from "react-icons/fa";

export const PrestationFollow = ({ defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  const { prestation, loading } = useSelector(state => state.prestation);
  const { status } = prestation;
  const { user } = useContext(UserContext);

  const inputs = inputsFollow({ prestation });

  const formRef = useRef(null);

  const context = useContext(ModalContext);
  const dispatch = useDispatch();
  const close = () => {
    setOpen(false);
    context.closeModal(modalsByContext.PrestationFollow);
  };
  const onSubmitForm = async data => {
    await dispatch(
      followPrestation({
        followedPrestation: prestation._id,
        ...data,
      }),
    );

    close();
  };

  const config = {
    key: prestation._id + modalsByContext.PrestationFollow,
    containerStyle: { minWidth: "600px" },
    title: "Voulez-vous créer une prestation de suivie ?",
    open: open,
    cancelText: "Fermer",
    okText: "Confirmer",
    onOk: () => {
      formRef.current.submit();
    },
    onCancel: close,
    content: (
      <>
        <Alert
          message={`Attention `}
          description={
            <>
              Merci de ne créer un suivi que si la prestation concerne{" "}
              <b>
                le même Demandeur, le même Bénéficiaire et le même Lieu
                d'intervention.
              </b>{" "}
              Dans le cas contraire, merci de contacter la permanence.
            </>
          }
          type="warning"
          showIcon
          closable={true}
        />
        <br />
        <p>Spécifier la date et l’heure de la prestation de suivi.</p>
        <CustomForm
          dataSource={inputs}
          handleSubmit={data => onSubmitForm(data)}
          labelCol={24}
          refForm={formRef}
          wrapperCol={24}
          onValuesChange={undefined}
        />
      </>
    ),
    footer: [
      <Button key="close" onClick={close}>
        Fermer
      </Button>,
      <Button
        icon={<FiCheckCircle size={20} />}
        type="primary"
        onClick={async () => {
          try {
            const test = await formRef.current.validateFields();
            formRef.current.submit();
          } catch (e) {
            notification.error({
              message: e.errorFields.length + " champs est nécessaire",
            });
          }
        }}
      >
        Confirmer et créer le suivi
      </Button>,
    ],
  };

  if (
    status === statusPrestationsValues.draft ||
    status === statusPrestationsValues.waiting
  ) {
    return null;
  }

  return (
    <>
      {createPortal(
        <Modal {...config}>{config.content}</Modal>,
        document.querySelector("#modals"),
      )}
    </>
  );
};

export const inputsFollow = ({ prestation, user }) => {
  const {
    name,
    secondName,
    type,
    archived,
    principal,
    mainType,
    tags,
    interventionLocation,
  } = prestation;
  const { id } = useParams();

  return [
    {
      parentLabel: "",
      children: [
        {
          required: true,
          label: "Date et heure de début",
          name: "intervention.startDate",
          value: dayjs(initstartDate),
          suffixIcon: <AiFillCalendar />,
          showTime: true,
          watch: "intervention.endDate",
          watchRenderCondition: false,
          watchValuesCallback: (start, end, ref) => {
            try {
              if (!end || !start) return;

              // Check the difference in minutes
              const differenceInMinutes = end.diff(start, "minute");

              // If start is after or exactly at the same time as end
              if (differenceInMinutes <= 0) {
                let newStartD = end.subtract(1, "hour");
                ref.current.setFieldsValue({
                  "intervention.startDate": newStartD,
                });
              }
            } catch (e) {
              console.log(e);
            }
          },
          type: "date",
          col: 12,
        },
        {
          required: true,
          label: "Date et heure de fin",
          name: "intervention.endDate",
          value: dayjs(initendDate),
          suffixIcon: <AiFillCalendar />,
          watch: "intervention.startDate",
          watchRenderCondition: false,
          watchValuesCallback: (end, start, ref) => {
            try {
              if (!end || !start) return;

              // Check the difference in minutes
              const differenceInMinutes = start.diff(end, "minute");

              // If end is before or exactly at the same time as start
              if (differenceInMinutes >= 0) {
                let newEndD = start.add(1, "hour");
                ref.current.setFieldsValue({
                  "intervention.endDate": newEndD,
                });
              }
            } catch (e) {
              console.log(e);
            }
          },
          showTime: true,
          type: "date",
          col: 12,
        },
        {
          label: "Lieu de l'intervention (Institution)",
          placeholder: "Modification d’intervenant sur place, de salle, …",
          required: true,
          value: prestation.intervention.locationName,
          name: "intervention.extra",
          disabled: !userHasLevel({
            only: {
              [roles.admin]: "r", //
              [roles.permanance]: "r", //
            },
          }),
          type: "input",
          col: 24,
        },
        {
          required: true,
          visible: prestation.intervention.type === typeIntervention.in_person,
          label: "Adresse d'intervention",
          name: "intervention.location",
          value: prestation.intervention.location,
          type: "google-adress",
          disabled: !userHasLevel({
            only: {
              [roles.admin]: "r", //
              [roles.permanance]: "r", //
            },
          }),
          col: 24,
        },
        {
          label: "Numéro de téléphone pour l'intervention",
          name: "intervention.phone",
          type: "input",
          required: true,
          value: prestation.intervention.phone,
          visible: prestation.intervention.type === typeIntervention.phone,
          addonBefore: "+41",
          col: 24,
        },
        {
          label: "Lien pour la visio-conférence",
          name: "intervention.linkVisio",
          type: "input",
          required: true,
          value: prestation.intervention.linkVisio,
          visible: prestation.intervention.type === typeIntervention.visio,
          addonBefore: <BiLinkExternal />,
          col: 24,
        },
      ],
    },
  ];
};
